<script lang="ts">
	import * as DropdownMenu from '$lib/components/ui/dropdown-menu';
	import * as Avatar from '$lib/components/ui/avatar';
	import type { SelectUser, SelectUserDetail } from '$db/tables';
	import UserRound from '@lucide/svelte/icons/user-round';
	import GraduationCap from '@lucide/svelte/icons/graduation-cap';
	import LogOut from '@lucide/svelte/icons/log-out';
	import UserCog from '@lucide/svelte/icons/user-cog';
	import SquareLibrary from '@lucide/svelte/icons/square-library';

	interface Props {
		user: SelectUser & { userDetails: SelectUserDetail | null };
	}

	let { user }: Props = $props();

	const initials = $derived(
		`${user.userDetails?.firstName.slice(0, 1)}${user.userDetails?.lastName.slice(0, 1)}`
	);

	const accountLink = $derived.by(() => {
		/* if (user.roles?.includes('admin')) {
			return '/admin/account';
		} */

		if (user.roles?.includes('teacher')) {
			return '/referenten/account';
		}

		return '/account';
	});
</script>

<DropdownMenu.Root>
	<DropdownMenu.Trigger
		><Avatar.Root class="rounded-md">
			<Avatar.Fallback class="rounded-md bg-secondary font-medium">{initials}</Avatar.Fallback>
		</Avatar.Root></DropdownMenu.Trigger
	>
	<DropdownMenu.Content class="min-w-56 rounded-lg" align="end" sideOffset={4}>
		<DropdownMenu.Label class="p-0 font-normal">
			<div class="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
				<Avatar.Root class="h-8 w-8 rounded-lg">
					<Avatar.Fallback class="rounded-lg bg-secondary">{initials}</Avatar.Fallback>
				</Avatar.Root>
				<div class="grid flex-1 text-left text-sm leading-tight">
					<span class="truncate font-semibold"
						>{user.userDetails?.firstName} {user.userDetails?.lastName}</span
					>
					<span class="truncate text-xs">{user.email}</span>
				</div>
			</div>
		</DropdownMenu.Label>
		<DropdownMenu.Separator />
		<DropdownMenu.Group>
			<DropdownMenu.Item>
				{#snippet child({ props })}
					<a href={accountLink} {...props}><UserRound />Mein Account</a>
				{/snippet}
			</DropdownMenu.Item>
			<DropdownMenu.Item class="whitespace-nowrap">
				{#snippet child({ props })}
					<a href="/buchungen" {...props}><SquareLibrary />Meine Buchungen</a>
				{/snippet}
			</DropdownMenu.Item>
			{#if user.roles?.includes('admin')}
				<DropdownMenu.Separator />
				<DropdownMenu.Item>
					{#snippet child({ props })}
						<a href="/admin" {...props}
							><UserCog />Adminseite<DropdownMenu.Shortcut class="tracking-normal"
								>Strg + I</DropdownMenu.Shortcut
							></a
						>
					{/snippet}
				</DropdownMenu.Item>
			{/if}
			{#if user.roles?.includes('teacher')}
				<DropdownMenu.Item>
					{#snippet child({ props })}
						<a href="/referenten/uebersicht" {...props}
							><GraduationCap />Referentenseite{#if user.roles?.includes('admin')}
								<DropdownMenu.Shortcut class="tracking-normal">Strg + O</DropdownMenu.Shortcut
								>{/if}</a
						>
					{/snippet}
				</DropdownMenu.Item>
			{/if}
		</DropdownMenu.Group>
		<DropdownMenu.Separator />
		<form method="POST" action="/logout">
			<button class="contents">
				<DropdownMenu.Item>
					<LogOut />
					Ausloggen
				</DropdownMenu.Item>
			</button>
		</form>
	</DropdownMenu.Content>
</DropdownMenu.Root>

<!-- <DropdownMenu.Root>
	<DropdownMenu.Trigger
		><Avatar.Root class="rounded-md">
			<Avatar.Fallback class="rounded-md bg-secondary font-medium"
				>{`${user.userDetails?.firstName.slice(0, 1)}${user.userDetails?.lastName.slice(
					0,
					1
				)}`}</Avatar.Fallback
			>
		</Avatar.Root></DropdownMenu.Trigger
	>
	<DropdownMenu.Content align="end" sideOffset={4}>
		<DropdownMenu.Label class="p-0 font-normal">
			<div class="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
				<Avatar.Root class="h-8 w-8 rounded-lg">
					<Avatar.Fallback class="rounded-lg"
						>{user.userDetails?.firstName.slice(0, 1)}
						{user.userDetails?.lastName.slice(0, 1)}</Avatar.Fallback
					>
				</Avatar.Root>
				<div class="grid flex-1 text-left text-sm leading-tight">
					<span class="truncate font-semibold"
						>{user.userDetails?.firstName} {user.userDetails?.lastName}</span
					>
					<span class="truncate text-xs">{user.email}</span>
				</div>
			</div>
		</DropdownMenu.Label>
		<DropdownMenu.Separator />
		<DropdownMenu.Group>
			<DropdownMenu.Item>
				{#snippet child({ props })}
					<a href="/account" {...props}>Mein Account</a>
				{/snippet}
			</DropdownMenu.Item>
			<DropdownMenu.Item class="whitespace-nowrap">
				{#snippet child({ props })}
					<a href="/buchungen" {...props}>Meine Buchungen</a>
				{/snippet}
			</DropdownMenu.Item>
			{#if page.data.user?.roles?.includes('admin')}
				<DropdownMenu.Separator />
				<DropdownMenu.Item class="group flex items-center justify-between gap-1">
					{#snippet child({ props })}
						<a href="/admin" {...props}>
							Adminseite <ArrowUpRight
								class="size-4 text-muted-foreground transition-all ease-in-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
							/>
						</a>
					{/snippet}
				</DropdownMenu.Item>
			{/if}
			{#if page.data.user?.roles?.includes('teacher') && !page.url.pathname.includes('/referenten')}
				<DropdownMenu.Item class="group flex items-center justify-between gap-1">
					{#snippet child({ props })}
						<a href="/referenten/uebersicht" {...props}>
							Referentenbereich <ArrowUpRight
								class="size-4 text-muted-foreground transition-all ease-in-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
							/>
						</a>
					{/snippet}
				</DropdownMenu.Item>
			{/if}
			<DropdownMenu.Separator />
			<form method="POST" action="/logout">
				<button class="contents">
					<DropdownMenu.Item>Ausloggen</DropdownMenu.Item>
				</button>
			</form>
		</DropdownMenu.Group>
	</DropdownMenu.Content>
</DropdownMenu.Root> -->
